import React, { useEffect, useState, useMemo } from 'react';
import Layouts from '../layouts/Layouts';
import { getAuthorizationHeader, http } from '../config/http';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import {
  IconCalendarTime,
  IconTrendingUp,
  IconTrendingDown,
  IconPercentage,
  IconCash,
  IconReportMoney,
  IconScale,
  IconBuildingStore,
  IconArrowUpRight,
  IconArrowDownRight,
  IconMinus,
  IconBrain,
  IconChartBar,
  IconChartPie,
  IconChartLine,
  IconPackage,
  IconPackageExport,
  IconPackageImport,
  IconAlertTriangle,
  IconBulb,
  IconChartDots3,
  IconReceipt,
  IconDiamond,
  IconInfoCircle,
  IconFilter,
  IconCheck,
} from '@tabler/icons-react';
import { DateRange } from 'react-date-range';
import moment from 'moment';
import { Line, Doughnut, Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import SpinnerGetData from '../components/common/SpinnerGetData';
import { DinamicTitle } from '../utils/DinamicTitle';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, ArcElement, Title, Tooltip, Legend, Filler);

// ============================================================
// DUMMY DATA — Ganti dengan API call setelah BE siap
// ============================================================
const DUMMY_DATA = {
  periode: { tgl_awal: '01-03-2026', tgl_akhir: '19-03-2026' },
  summary: {
    total_penjualan: 150000000,
    total_pembelian_hpp: 95000000,
    total_pengeluaran: 15000000,
    laba_kotor: 55000000,
    laba_bersih: 40000000,
    gross_profit_margin: 36.67,
    net_profit_margin: 26.67,
    total_gram_terjual: 450.5,
    total_item_terjual: 120,
    avg_harga_per_gram: 333000,
    avg_gram_per_item: 3.75,
    profit_per_item: 458333,
    cabang_terbaik: { nama: 'Aikmel', total_penjualan: 80000000 },
    // Data Baru untuk Estimasi Profit
    avg_selling_price_today: 348000,
    avg_selling_price_week: 342000,
    current_stock_weight: 1250.75,
    current_stock_cost: 375000000,
    projected_profit_from_stock: 52500000,
  },
  inventory: {
    stok_masuk: 200,
    stok_keluar: 120,
    stok_tersisa: 580,
    stok_masuk_gram: 750.0,
    stok_keluar_gram: 450.5,
    dead_stock: 45,
  },
  per_cabang: [
    { id_cabang: 1, nama_cabang: 'Aikmel', total_penjualan: 80000000, total_pembelian_hpp: 50000000, laba_kotor: 30000000, laba_bersih: 22000000, total_gram: 200.5, total_item: 50, gross_profit_margin: 37.5, pembelian_gram: 300.0, penjualan_gram: 200.5 },
    { id_cabang: 2, nama_cabang: 'Pancor', total_penjualan: 35000000, total_pembelian_hpp: 22000000, laba_kotor: 13000000, laba_bersih: 9500000, total_gram: 105.2, total_item: 30, gross_profit_margin: 37.14, pembelian_gram: 180.0, penjualan_gram: 105.2 },
    { id_cabang: 3, nama_cabang: 'Kebon Roek', total_penjualan: 20000000, total_pembelian_hpp: 13000000, laba_kotor: 7000000, laba_bersih: 5000000, total_gram: 85.3, total_item: 25, gross_profit_margin: 35.0, pembelian_gram: 150.0, penjualan_gram: 85.3 },
    { id_cabang: 4, nama_cabang: 'Keruak', total_penjualan: 15000000, total_pembelian_hpp: 10000000, laba_kotor: 5000000, laba_bersih: 3500000, total_gram: 59.5, total_item: 15, gross_profit_margin: 33.33, pembelian_gram: 120.0, penjualan_gram: 59.5 },
  ],
  trend: [
    { label: '01 Mar', total_penjualan: 7000000, laba_kotor: 2500000, laba_bersih: 1800000 },
    { label: '03 Mar', total_penjualan: 9500000, laba_kotor: 3500000, laba_bersih: 2500000 },
    { label: '05 Mar', total_penjualan: 6000000, laba_kotor: 2200000, laba_bersih: 1500000 },
    { label: '07 Mar', total_penjualan: 11000000, laba_kotor: 4000000, laba_bersih: 3000000 },
    { label: '09 Mar', total_penjualan: 8500000, laba_kotor: 3100000, laba_bersih: 2200000 },
    { label: '11 Mar', total_penjualan: 12000000, laba_kotor: 4500000, laba_bersih: 3200000 },
    { label: '13 Mar', total_penjualan: 10000000, laba_kotor: 3700000, laba_bersih: 2600000 },
    { label: '15 Mar', total_penjualan: 14000000, laba_kotor: 5200000, laba_bersih: 3800000 },
    { label: '17 Mar', total_penjualan: 8000000, laba_kotor: 2900000, laba_bersih: 2100000 },
    { label: '19 Mar', total_penjualan: 13000000, laba_kotor: 4800000, laba_bersih: 3500000 },
  ],
  // Rata-rata harga per gram mingguan (dari HARGA_JUAL / BERAT per transaksi, lalu dirata-rata per minggu)
  avg_harga_per_gram_mingguan: [
    { label: 'Minggu 1 (01-07 Mar)', avg_harga_per_gram: 325000, total_transaksi: 32, total_gram: 128.5, total_penjualan: 41750000 },
    { label: 'Minggu 2 (08-14 Mar)', avg_harga_per_gram: 338000, total_transaksi: 45, total_gram: 167.3, total_penjualan: 56537400 },
    { label: 'Minggu 3 (15-19 Mar)', avg_harga_per_gram: 342000, total_transaksi: 43, total_gram: 154.7, total_penjualan: 52907400 },
  ],
  insight_harga_per_gram: {
    tren: 'naik',
    perubahan_persen: 5.23,
    minggu_tertinggi: { label: 'Minggu 3 (15-19 Mar)', avg_harga_per_gram: 342000 },
    minggu_terendah: { label: 'Minggu 1 (01-07 Mar)', avg_harga_per_gram: 325000 },
  },
  avg_harga_per_gram_harian: [
    { label: '01 Mar', avg_harga_per_gram: 325000, total_transaksi: 4, total_gram: 15.5, total_penjualan: 5037500 },
    { label: '03 Mar', avg_harga_per_gram: 328000, total_transaksi: 5, total_gram: 20.3, total_penjualan: 6658400 },
    { label: '05 Mar', avg_harga_per_gram: 330000, total_transaksi: 3, total_gram: 10.5, total_penjualan: 3465000 },
    { label: '07 Mar', avg_harga_per_gram: 335000, total_transaksi: 6, total_gram: 25.1, total_penjualan: 8408500 },
    { label: '09 Mar', avg_harga_per_gram: 332000, total_transaksi: 4, total_gram: 18.0, total_penjualan: 5976000 },
    { label: '11 Mar', avg_harga_per_gram: 340000, total_transaksi: 7, total_gram: 30.2, total_penjualan: 10268000 },
    { label: '13 Mar', avg_harga_per_gram: 338000, total_transaksi: 5, total_gram: 22.4, total_penjualan: 7571200 },
    { label: '15 Mar', avg_harga_per_gram: 345000, total_transaksi: 8, total_gram: 35.5, total_penjualan: 12247500 },
    { label: '17 Mar', avg_harga_per_gram: 342000, total_transaksi: 4, total_gram: 16.8, total_penjualan: 5745600 },
    { label: '19 Mar', avg_harga_per_gram: 348000, total_transaksi: 6, total_gram: 28.5, total_penjualan: 9918000 },
  ],
  insight_harga_per_gram_harian: {
    tren: 'naik',
    perubahan_persen: 7.07,
    hari_tertinggi: { label: '19 Mar', avg_harga_per_gram: 348000 },
    hari_terendah: { label: '01 Mar', avg_harga_per_gram: 325000 },
  },
};

// ============================================================
// UTILITY
// ============================================================
function fmt(x) {
  if (x === null || x === undefined) return '0';
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

// ============================================================
// AI INSIGHT CALCULATIONS (FE-side from dummy/real data)
// ============================================================
function computeAiInsights(data) {
  if (!data) return [];
  const insights = [];
  const { trend, per_cabang, summary, inventory } = data;

  // 1. Prediksi Penjualan — simple moving average dari 3 data terakhir
  if (trend && trend.length >= 3) {
    const last3 = trend.slice(-3).map((t) => t.total_penjualan);
    const avg = Math.round(last3.reduce((a, b) => a + b, 0) / 3);
    const lastVal = trend[trend.length - 1].total_penjualan;
    const direction = avg > lastVal ? 'naik' : 'turun';
    insights.push({
      icon: IconChartDots3,
      color: 'blue',
      title: 'Prediksi Penjualan',
      text: `Berdasarkan rata-rata 3 hari terakhir, prediksi penjualan berikutnya sekitar Rp ${fmt(avg)}. Tren cenderung ${direction}.`,
    });
  }

  // 2. Rekomendasi Stok — cabang dengan penjualan tertinggi butuh stok lebih
  if (per_cabang && per_cabang.length > 0) {
    const sorted = [...per_cabang].sort((a, b) => b.total_penjualan - a.total_penjualan);
    const top = sorted[0];
    const low = sorted[sorted.length - 1];
    insights.push({
      icon: IconBulb,
      color: 'amber',
      title: 'Rekomendasi Stok',
      text: `${top.nama_cabang} memiliki penjualan tertinggi (Rp ${fmt(top.total_penjualan)}), pastikan stok tercukupi. ${low.nama_cabang} paling rendah — evaluasi strategi penjualan.`,
    });
  }

  // 3. Deteksi Anomali — cabang dengan margin jauh di bawah rata-rata
  if (per_cabang && per_cabang.length > 1) {
    const avgMargin = per_cabang.reduce((a, c) => a + (c.gross_profit_margin || 0), 0) / per_cabang.length;
    const anomalies = per_cabang.filter((c) => c.gross_profit_margin < avgMargin - 3);
    if (anomalies.length > 0) {
      insights.push({
        icon: IconAlertTriangle,
        color: 'rose',
        title: 'Deteksi Anomali',
        text: `${anomalies.map((a) => a.nama_cabang).join(', ')} memiliki margin (${anomalies.map((a) => a.gross_profit_margin?.toFixed(1) + '%').join(', ')}) di bawah rata-rata ${avgMargin.toFixed(1)}%. Perlu investigasi.`,
      });
    } else {
      insights.push({
        icon: IconAlertTriangle,
        color: 'emerald',
        title: 'Status Normal',
        text: `Semua cabang memiliki margin dalam rentang normal (rata-rata ${avgMargin.toFixed(1)}%). Tidak ada anomali terdeteksi.`,
      });
    }
  }

  // 4. Estimasi Profit Stok — berdasarkan harga rata-rata minggu ini
  if (summary && summary.projected_profit_from_stock) {
    insights.push({
      icon: IconBrain,
      color: 'purple',
      title: 'Estimasi Profit Stok',
      text: `Stok tersisa (${fmt(summary.current_stock_weight)} gr) diprediksi menghasilkan laba bersih Rp ${fmt(summary.projected_profit_from_stock)} jika terjual dengan harga rata-rata Rp ${fmt(summary.avg_selling_price_week)}/gr.`,
    });
  }

  return insights;
}

// ============================================================
// SUB-COMPONENTS
// ============================================================

/** Section header */
const SectionHeader = ({ icon: Icon, title, subtitle }) => (
  <div className="flex items-center gap-3 mb-4">
    <div className="p-2 bg-amber-500/10 dark:bg-amber-500/20 rounded-xl">
      <Icon className="text-amber-600 dark:text-amber-400" size={22} />
    </div>
    <div>
      <h3 className="text-base sm:text-lg font-bold text-slate-800 dark:text-slate-100">{title}</h3>
      {subtitle && <p className="text-xs text-slate-500 dark:text-slate-400">{subtitle}</p>}
    </div>
  </div>
);

/** KPI Card */
const KpiCard = ({ title, value, suffix, icon: Icon, color, subLabel, subValue, trend }) => {
  const colors = {
    amber: { bg: 'from-amber-50 to-amber-100/50 dark:from-amber-500/10 dark:to-amber-600/5', border: 'border-amber-200/60 dark:border-amber-500/20', iconBg: 'bg-amber-500', text: 'text-amber-700 dark:text-amber-400' },
    emerald: { bg: 'from-emerald-50 to-emerald-100/50 dark:from-emerald-500/10 dark:to-emerald-600/5', border: 'border-emerald-200/60 dark:border-emerald-500/20', iconBg: 'bg-emerald-500', text: 'text-emerald-700 dark:text-emerald-400' },
    green: { bg: 'from-green-50 to-green-100/50 dark:from-green-500/10 dark:to-green-600/5', border: 'border-green-200/60 dark:border-green-500/20', iconBg: 'bg-green-600', text: 'text-green-700 dark:text-green-400' },
    blue: { bg: 'from-blue-50 to-blue-100/50 dark:from-blue-500/10 dark:to-blue-600/5', border: 'border-blue-200/60 dark:border-blue-500/20', iconBg: 'bg-blue-500', text: 'text-blue-700 dark:text-blue-400' },
    purple: { bg: 'from-purple-50 to-purple-100/50 dark:from-purple-500/10 dark:to-purple-600/5', border: 'border-purple-200/60 dark:border-purple-500/20', iconBg: 'bg-purple-500', text: 'text-purple-700 dark:text-purple-400' },
    rose: { bg: 'from-rose-50 to-rose-100/50 dark:from-rose-500/10 dark:to-rose-600/5', border: 'border-rose-200/60 dark:border-rose-500/20', iconBg: 'bg-rose-500', text: 'text-rose-700 dark:text-rose-400' },
    slate: { bg: 'from-slate-50 to-slate-100/50 dark:from-slate-500/10 dark:to-slate-600/5', border: 'border-slate-200/60 dark:border-slate-500/20', iconBg: 'bg-slate-600', text: 'text-slate-700 dark:text-slate-300' },
  };
  const c = colors[color] || colors.amber;
  const TrendIcon = trend > 0 ? IconArrowUpRight : trend < 0 ? IconArrowDownRight : IconMinus;
  const trendColor = trend > 0 ? 'text-emerald-600 dark:text-emerald-400' : trend < 0 ? 'text-rose-600 dark:text-rose-400' : 'text-slate-400';

  return (
    <div className={`bg-gradient-to-br ${c.bg} ${c.border} border rounded-2xl p-4 sm:p-5 shadow-sm hover:shadow-md transition-all duration-300 min-w-[160px] flex-shrink-0`}>
      <div className="flex items-start justify-between mb-3">
        <div className={`${c.iconBg} p-2 rounded-xl shadow-sm`}>
          <Icon className="text-white w-4 h-4 sm:w-5 sm:h-5" />
        </div>
        {trend !== undefined && trend !== null && (
          <div className={`flex items-center gap-0.5 text-xs font-bold ${trendColor}`}>
            <TrendIcon size={14} />
          </div>
        )}
      </div>
      <h4 className="text-[10px] sm:text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400 mb-1">{title}</h4>
      <p className={`text-lg sm:text-2xl font-black ${c.text} tracking-tight leading-tight`}>
        {value}<span className="text-sm sm:text-base font-bold ml-0.5">{suffix}</span>
      </p>
      {subLabel && (
        <p className="text-[10px] sm:text-xs text-slate-500 dark:text-slate-400 mt-1.5 font-medium truncate">
          {subLabel}: <span className="font-bold text-slate-700 dark:text-slate-300">{subValue}</span>
        </p>
      )}
    </div>
  );
};

/** Small metric card for productivity / inventory */
const MetricCard = ({ label, value, suffix, icon: Icon, color }) => {
  const bgMap = { amber: 'bg-amber-500', emerald: 'bg-emerald-500', blue: 'bg-blue-500', purple: 'bg-purple-500', rose: 'bg-rose-500', green: 'bg-green-600', slate: 'bg-slate-600' };
  const textMap = { amber: 'text-amber-700 dark:text-amber-400', emerald: 'text-emerald-700 dark:text-emerald-400', blue: 'text-blue-700 dark:text-blue-400', purple: 'text-purple-700 dark:text-purple-400', rose: 'text-rose-700 dark:text-rose-400', green: 'text-green-700 dark:text-green-400', slate: 'text-slate-700 dark:text-slate-300' };

  return (
    <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl p-4 shadow-sm flex items-center gap-3">
      <div className={`${bgMap[color] || bgMap.amber} p-2.5 rounded-xl shadow-sm flex-shrink-0`}>
        <Icon className="text-white w-5 h-5" />
      </div>
      <div className="min-w-0">
        <p className="text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider truncate">{label}</p>
        <p className={`text-lg sm:text-xl font-black ${textMap[color] || textMap.amber} leading-tight`}>{value}<span className="text-sm font-bold ml-0.5">{suffix}</span></p>
      </div>
    </div>
  );
};

/** AI Insight Card */
const InsightCard = ({ icon: Icon, color, title, text }) => {
  const borderMap = { blue: 'border-l-blue-500', amber: 'border-l-amber-500', rose: 'border-l-rose-500', emerald: 'border-l-emerald-500' };
  const iconBgMap = { blue: 'bg-blue-500/10 text-blue-600 dark:text-blue-400', amber: 'bg-amber-500/10 text-amber-600 dark:text-amber-400', rose: 'bg-rose-500/10 text-rose-600 dark:text-rose-400', emerald: 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400' };

  return (
    <div className={`bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 border-l-4 ${borderMap[color] || borderMap.blue} rounded-xl p-4 shadow-sm`}>
      <div className="flex items-center gap-2 mb-2">
        <div className={`p-1.5 rounded-lg ${iconBgMap[color] || iconBgMap.blue}`}>
          <Icon size={16} />
        </div>
        <h4 className="text-sm font-bold text-slate-800 dark:text-slate-100">{title}</h4>
      </div>
      <p className="text-xs sm:text-sm text-slate-600 dark:text-slate-400 leading-relaxed">{text}</p>
    </div>
  );
};

// ============================================================
// MAIN COMPONENT
// ============================================================
const DashboardKeuangan = () => {
  DinamicTitle('Dashboard Keuangan || Komaladewi');
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedKarat, setSelectedKarat] = useState([]); // State untuk multiselect karat (16..24)
  const listKarat = [15, 16, 17, 18, 19, 20, 21, 22, 23, 24]; // Pilihan karat

  const awal = startDate ? moment(startDate).format('DD-MM-YYYY') : moment().startOf('month').format('DD-MM-YYYY');
  const akhir = endDate ? moment(endDate).format('DD-MM-YYYY') : moment().format('DD-MM-YYYY');

  function handleSelect(date) {
    setStartDate(date.selection.startDate);
    setEndDate(date.selection.endDate);
  }

  function handleSelectKarat(karat) {
    if (selectedKarat.includes(karat)) {
      setSelectedKarat(selectedKarat.filter((k) => k !== karat));
    } else {
      setSelectedKarat([...selectedKarat, karat]);
    }
  }

  const selectionRange = { startDate: startDate || moment().startOf('month').toDate(), endDate: endDate || new Date(), key: 'selection' };

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      try {
        // TODO: Ganti dengan API call setelah BE siap
        const q = `?tgl_awal=${awal}&tgl_akhir=${akhir}` + (selectedKarat.length > 0 ? `&karat=${selectedKarat.join(',')}` : '');
        const res = await http.get(`dashboard-keuangan-v2${q}`, { headers: { Authorization: getAuthorizationHeader() } });
        setData(res.data);
        await new Promise((r) => setTimeout(r, 500));
        // setData(DUMMY_DATA);
      } catch (err) {
        if (err.code === 'ERR_NETWORK') toast.warning('Periksa jaringan internet', { autoClose: 600 });
        else if (err.response?.status === 401) navigate('/login');
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [navigate, awal, akhir, selectedKarat]);

  const s = data?.summary;
  const inv = data?.inventory;
  const aiInsights = useMemo(() => computeAiInsights(data), [data]);

  // ====== CHART: Trend Penjualan (Line) ======
  const trendChartData = useMemo(() => {
    if (!data?.trend) return null;
    return {
      labels: data.trend.map((t) => t.label),
      datasets: [
        {
          label: 'Penjualan',
          data: data.trend.map((t) => t.total_penjualan),
          borderColor: '#f59e0b',
          backgroundColor: 'rgba(245,158,11,0.08)',
          fill: true,
          tension: 0.4,
          borderWidth: 2.5,
          pointRadius: 4,
          pointBackgroundColor: '#f59e0b',
          pointBorderColor: '#fff',
          pointBorderWidth: 2,
          pointHoverRadius: 6,
        },
        {
          label: 'Laba Kotor',
          data: data.trend.map((t) => t.laba_kotor),
          borderColor: '#10b981',
          backgroundColor: 'rgba(16,185,129,0.08)',
          fill: true,
          tension: 0.4,
          borderWidth: 2,
          pointRadius: 3,
          pointBackgroundColor: '#10b981',
          pointBorderColor: '#fff',
          pointBorderWidth: 2,
          borderDash: [5, 3],
        },
      ],
    };
  }, [data]);

  const lineOptions = {
    responsive: true, maintainAspectRatio: false,
    interaction: { mode: 'index', intersect: false },
    plugins: {
      legend: { position: 'top', labels: { usePointStyle: true, pointStyle: 'circle', padding: 16, font: { size: 11, weight: 'bold' } } },
      tooltip: { backgroundColor: 'rgba(15,23,42,0.9)', padding: 12, cornerRadius: 8, callbacks: { label: (ctx) => `${ctx.dataset.label}: Rp ${fmt(ctx.parsed.y)}` } },
    },
    scales: {
      y: { beginAtZero: true, ticks: { callback: (v) => 'Rp ' + fmt(v), font: { size: 10 } }, grid: { color: 'rgba(148,163,184,0.1)' } },
      x: { ticks: { font: { size: 10 } }, grid: { display: false } },
    },
  };

  // ====== CHART: Pie per Cabang ======
  const pieChartData = useMemo(() => {
    if (!data?.per_cabang) return null;
    const pieColors = ['#f59e0b', '#10b981', '#3b82f6', '#a855f7', '#ef4444', '#06b6d4'];
    return {
      labels: data.per_cabang.map((c) => c.nama_cabang),
      datasets: [{
        data: data.per_cabang.map((c) => c.total_penjualan),
        backgroundColor: pieColors.slice(0, data.per_cabang.length),
        borderColor: '#fff',
        borderWidth: 2,
        hoverOffset: 8,
      }],
    };
  }, [data]);

  const pieOptions = {
    responsive: true, maintainAspectRatio: false,
    plugins: {
      legend: { position: 'bottom', labels: { usePointStyle: true, pointStyle: 'circle', padding: 14, font: { size: 11, weight: 'bold' } } },
      tooltip: { callbacks: { label: (ctx) => `${ctx.label}: Rp ${fmt(ctx.parsed)}` } },
    },
  };

  // ====== CHART: Bar Penjualan vs Laba per Cabang ======
  const barChartData = useMemo(() => {
    if (!data?.per_cabang) return null;
    return {
      labels: data.per_cabang.map((c) => c.nama_cabang),
      datasets: [
        { label: 'Penjualan', data: data.per_cabang.map((c) => c.total_penjualan), backgroundColor: 'rgba(245,158,11,0.7)', borderRadius: 6, barPercentage: 0.6 },
        { label: 'Laba Kotor', data: data.per_cabang.map((c) => c.laba_kotor), backgroundColor: 'rgba(16,185,129,0.7)', borderRadius: 6, barPercentage: 0.6 },
      ],
    };
  }, [data]);

  // ====== CHART: Bar Pembelian vs Penjualan (gram) ======
  const inventoryBarData = useMemo(() => {
    if (!data?.per_cabang) return null;
    return {
      labels: data.per_cabang.map((c) => c.nama_cabang),
      datasets: [
        { label: 'Pembelian (gr)', data: data.per_cabang.map((c) => c.pembelian_gram), backgroundColor: 'rgba(59,130,246,0.7)', borderRadius: 6, barPercentage: 0.6 },
        { label: 'Penjualan (gr)', data: data.per_cabang.map((c) => c.penjualan_gram), backgroundColor: 'rgba(245,158,11,0.7)', borderRadius: 6, barPercentage: 0.6 },
      ],
    };
  }, [data]);

  // ====== CHART: Rata-rata Harga per Gram Mingguan ======
  const weeklyPriceChartData = useMemo(() => {
    if (!data?.avg_harga_per_gram_mingguan) return null;
    const weeks = data.avg_harga_per_gram_mingguan;
    return {
      labels: weeks.map((w) => w.label),
      datasets: [
        {
          type: 'line',
          label: 'Rata-rata Harga/Gram',
          data: weeks.map((w) => w.avg_harga_per_gram),
          borderColor: '#f59e0b',
          backgroundColor: 'rgba(245,158,11,0.1)',
          fill: true,
          tension: 0.4,
          borderWidth: 3,
          pointRadius: 6,
          pointBackgroundColor: '#f59e0b',
          pointBorderColor: '#fff',
          pointBorderWidth: 3,
          pointHoverRadius: 8,
          yAxisID: 'y',
        },
        {
          type: 'bar',
          label: 'Total Gram',
          data: weeks.map((w) => w.total_gram),
          backgroundColor: 'rgba(59,130,246,0.25)',
          borderColor: 'rgba(59,130,246,0.5)',
          borderWidth: 1,
          borderRadius: 8,
          barPercentage: 0.5,
          yAxisID: 'y1',
        },
      ],
    };
  }, [data]);

  const weeklyPriceOptions = {
    responsive: true, maintainAspectRatio: false,
    interaction: { mode: 'index', intersect: false },
    plugins: {
      legend: { position: 'top', labels: { usePointStyle: true, pointStyle: 'circle', padding: 16, font: { size: 11, weight: 'bold' } } },
      tooltip: {
        backgroundColor: 'rgba(15,23,42,0.9)', padding: 12, cornerRadius: 8,
        callbacks: {
          label: (ctx) => {
            if (ctx.datasetIndex === 0) return `${ctx.dataset.label}: Rp ${fmt(ctx.parsed.y)}`;
            return `${ctx.dataset.label}: ${ctx.parsed.y} gr`;
          },
        },
      },
    },
    scales: {
      y: {
        type: 'linear', position: 'left',
        beginAtZero: false,
        ticks: { callback: (v) => 'Rp ' + fmt(v), font: { size: 10 } },
        grid: { color: 'rgba(148,163,184,0.1)' },
        title: { display: true, text: 'Harga/Gram (Rp)', font: { size: 10, weight: 'bold' }, color: '#f59e0b' },
      },
      y1: {
        type: 'linear', position: 'right',
        beginAtZero: true,
        ticks: { callback: (v) => v + ' gr', font: { size: 10 } },
        grid: { display: false },
        title: { display: true, text: 'Total Gram', font: { size: 10, weight: 'bold' }, color: '#3b82f6' },
      },
      x: { ticks: { font: { size: 10 }, maxRotation: 0 }, grid: { display: false } },
    },
  };

  const insightHarga = data?.insight_harga_per_gram;

  // ====== CHART: Rata-rata Harga per Gram Harian ======
  const dailyPriceChartData = useMemo(() => {
    if (!data?.avg_harga_per_gram_harian) return null;
    const days = data.avg_harga_per_gram_harian;
    return {
      labels: days.map((d) => d.label),
      datasets: [
        {
          type: 'line',
          label: 'Rata-rata Harga/Gram',
          data: days.map((d) => d.avg_harga_per_gram),
          borderColor: '#10b981',
          backgroundColor: 'rgba(16,185,129,0.1)',
          fill: true,
          tension: 0.4,
          borderWidth: 3,
          pointRadius: 6,
          pointBackgroundColor: '#10b981',
          pointBorderColor: '#fff',
          pointBorderWidth: 3,
          pointHoverRadius: 8,
          yAxisID: 'y',
        },
        {
          type: 'bar',
          label: 'Total Gram',
          data: days.map((d) => d.total_gram),
          backgroundColor: 'rgba(168,85,247,0.25)',
          borderColor: 'rgba(168,85,247,0.5)',
          borderWidth: 1,
          borderRadius: 8,
          barPercentage: 0.5,
          yAxisID: 'y1',
        },
      ],
    };
  }, [data]);

  const dailyPriceOptions = {
    responsive: true, maintainAspectRatio: false,
    interaction: { mode: 'index', intersect: false },
    plugins: {
      legend: { position: 'top', labels: { usePointStyle: true, pointStyle: 'circle', padding: 16, font: { size: 11, weight: 'bold' } } },
      tooltip: {
        backgroundColor: 'rgba(15,23,42,0.9)', padding: 12, cornerRadius: 8,
        callbacks: {
          label: (ctx) => {
            if (ctx.datasetIndex === 0) return `${ctx.dataset.label}: Rp ${fmt(ctx.parsed.y)}`;
            return `${ctx.dataset.label}: ${ctx.parsed.y} gr`;
          },
        },
      },
    },
    scales: {
      y: {
        type: 'linear', position: 'left',
        beginAtZero: false,
        ticks: { callback: (v) => 'Rp ' + fmt(v), font: { size: 10 } },
        grid: { color: 'rgba(148,163,184,0.1)' },
        title: { display: true, text: 'Harga/Gram (Rp)', font: { size: 10, weight: 'bold' }, color: '#10b981' },
      },
      y1: {
        type: 'linear', position: 'right',
        beginAtZero: true,
        ticks: { callback: (v) => v + ' gr', font: { size: 10 } },
        grid: { display: false },
        title: { display: true, text: 'Total Gram', font: { size: 10, weight: 'bold' }, color: '#a855f7' },
      },
      x: { ticks: { font: { size: 10 }, maxRotation: 0 }, grid: { display: false } },
    },
  };

  const insightHargaHarian = data?.insight_harga_per_gram_harian;

  const barOptions = {
    responsive: true, maintainAspectRatio: false,
    plugins: {
      legend: { position: 'top', labels: { usePointStyle: true, pointStyle: 'circle', padding: 16, font: { size: 11, weight: 'bold' } } },
      tooltip: { backgroundColor: 'rgba(15,23,42,0.9)', padding: 12, cornerRadius: 8 },
    },
    scales: {
      y: { beginAtZero: true, ticks: { font: { size: 10 } }, grid: { color: 'rgba(148,163,184,0.1)' } },
      x: { ticks: { font: { size: 10 } }, grid: { display: false } },
    },
  };

  const barOptionsRp = {
    ...barOptions,
    plugins: { ...barOptions.plugins, tooltip: { ...barOptions.plugins.tooltip, callbacks: { label: (ctx) => `${ctx.dataset.label}: Rp ${fmt(ctx.parsed.y)}` } } },
    scales: { ...barOptions.scales, y: { ...barOptions.scales.y, ticks: { ...barOptions.scales.y.ticks, callback: (v) => 'Rp ' + fmt(v) } } },
  };

  // Compute trend insight text
  const trendInsight = useMemo(() => {
    if (!data?.trend || data.trend.length < 2) return null;
    const vals = data.trend.map((t) => t.total_penjualan);
    const first = vals[0]; const last = vals[vals.length - 1];
    const pct = (((last - first) / first) * 100).toFixed(1);
    const dir = last > first ? 'naik' : 'turun';
    const max = Math.max(...vals); const min = Math.min(...vals);
    const volatility = (((max - min) / ((max + min) / 2)) * 100).toFixed(0);
    return { dir, pct: Math.abs(pct), volatility };
  }, [data]);

  return (
    <Layouts
      // title="Dashboard Keuangan"
      compFilter={
        <div className="flex items-center gap-2">
          {/* FILTER KARAT */}
          <div className="dropdown dropdown-end">
            <div tabIndex={0} className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-200 p-2.5 rounded-lg cursor-pointer transition-colors shadow-sm flex items-center gap-2">
              <IconFilter size={20} />
              <span className="hidden sm:inline font-medium">
                {selectedKarat.length === 0 ? 'Semua Karat' : `Karat (${selectedKarat.length})`}
              </span>
            </div>
            <div tabIndex={0} className="dropdown-content z-[50] mt-2 w-56 p-3 shadow-2xl bg-white dark:bg-slate-800 border dark:border-slate-700 rounded-xl">
              <div className="font-bold text-slate-800 dark:text-slate-100 mb-2 border-b dark:border-slate-700 pb-2">Filter Karat</div>
              <div className="grid grid-cols-2 gap-2 max-h-64 overflow-y-auto pr-1">
                {listKarat.map((k) => (
                  <label key={k} className="flex items-center gap-2 cursor-pointer hover:bg-slate-50 dark:hover:bg-slate-700 p-1.5 rounded-lg transition-colors">
                    <input
                      type="checkbox"
                      className="checkbox checkbox-sm checkbox-warning rounded-md"
                      checked={selectedKarat.includes(k)}
                      onChange={() => handleSelectKarat(k)}
                    />
                    <span className="text-sm font-medium text-slate-700 dark:text-slate-300">{k}</span>
                  </label>
                ))}
              </div>
              {selectedKarat.length > 0 && (
                <div className="mt-3 pt-2 border-t dark:border-slate-700">
                  <button onClick={() => setSelectedKarat([])} className="text-xs text-rose-500 hover:text-rose-600 font-bold w-full text-center">
                    Reset Karat
                  </button>
                </div>
              )}
            </div>
          </div>

          {/* FILTER TANGGAL */}
          <div className="dropdown dropdown-end">
            <div tabIndex={0} className="bg-amber-500 hover:bg-amber-600 text-white p-2.5 rounded-lg cursor-pointer transition-colors shadow-sm flex items-center gap-2">
              <IconCalendarTime size={20} />
              <span className="hidden sm:inline font-medium">Filter Tanggal</span>
            </div>
            <div tabIndex={0} className="dropdown-content z-[50] mt-2 p-2 shadow-2xl bg-white dark:bg-slate-800 border dark:border-slate-700 rounded-xl">
              <DateRange ranges={[selectionRange]} onChange={handleSelect} rangeColors={['#f59e0b']} className="dark:text-slate-800" />
            </div>
          </div>
        </div>
      }
    >
      {loading ? (
        <div className="flex items-center justify-center min-h-[60vh]">
          <div className="text-center">
            <SpinnerGetData />
            <p className="mt-3 text-slate-500 dark:text-slate-400 font-medium">Memuat data...</p>
          </div>
        </div>
      ) : data ? (
        <div className="p-3 sm:p-5 dark:bg-slate-950 min-h-screen space-y-6">
          {/* PERIODE BADGE */}
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
            <h2 className="text-xl sm:text-2xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-3">
              <div className="p-2 bg-amber-500/10 rounded-lg"><IconChartBar className="text-amber-500" size={24} /></div>
              Laporan Keuangan
            </h2>
            <div className="px-4 py-2 bg-amber-50 dark:bg-amber-500/10 border border-amber-100 dark:border-amber-500/20 rounded-lg">
              <span className="text-amber-800 dark:text-amber-400 font-medium text-sm">
                Periode: <span className="font-bold">{awal}</span> — <span className="font-bold">{akhir}</span>
              </span>
            </div>
          </div>

          {/* ═══════ A. TOP KPI CARDS ═══════ */}
          <div className="overflow-x-auto scrollbar-none -mx-3 px-3">
            <div className="flex gap-3 sm:grid sm:grid-cols-3 lg:grid-cols-6 min-w-max sm:min-w-0">
              <KpiCard title="Total Penjualan" value={`Rp ${fmt(s?.total_penjualan)}`} icon={IconCash} color="emerald" trend={1} subLabel="HPP" subValue={`Rp ${fmt(s?.total_pembelian_hpp)}`} />
              <KpiCard title="Laba Kotor" value={`Rp ${fmt(s?.laba_kotor)}`} icon={IconTrendingUp} color="amber" trend={1} subLabel="GPM" subValue={`${s?.gross_profit_margin}%`} />
              <KpiCard title="Laba Bersih" value={`Rp ${fmt(s?.laba_bersih)}`} icon={IconReportMoney} color="green" trend={1} subLabel="NPM" subValue={`${s?.net_profit_margin}%`} />
              <KpiCard title="Estimasi Profit Stok" value={`Rp ${fmt(s?.projected_profit_from_stock)}`} icon={IconBrain} color="purple" subLabel="Harga Acuan" subValue={`Rp ${fmt(s?.avg_selling_price_week)}`} />
              <KpiCard title="Gram Terjual" value={`${s?.total_gram_terjual}`} suffix=" gr" icon={IconScale} color="blue" subLabel="Item" subValue={`${s?.total_item_terjual} pcs`} />
              <KpiCard title="Cabang Terbaik" value={s?.cabang_terbaik?.nama} icon={IconBuildingStore} color="rose" subLabel="Penjualan" subValue={`Rp ${fmt(s?.cabang_terbaik?.total_penjualan)}`} />
            </div>
          </div>

          {/* ═══════ AI INSIGHTS ═══════ */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            {aiInsights.map((insight, i) => (
              <InsightCard key={i} {...insight} />
            ))}
          </div>

          {/* ═══════ B. GRAFIK UTAMA ═══════ */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
            {/* Line Chart — Trend */}
            <div className="lg:col-span-2 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-4 sm:p-5 shadow-sm">
              <SectionHeader icon={IconTrendingUp} title="Trend Penjualan" subtitle="Penjualan harian dengan overlay laba" />
              <div className="h-[260px] sm:h-[300px]">
                {trendChartData && <Line data={trendChartData} options={lineOptions} />}
              </div>
              {trendInsight && (
                <div className="mt-3 p-3 bg-slate-50 dark:bg-slate-800/50 rounded-xl text-xs text-slate-600 dark:text-slate-400 flex items-start gap-2">
                  <IconInfoCircle size={16} className="text-amber-500 mt-0.5 flex-shrink-0" />
                  <span>
                    Tren <strong className={trendInsight.dir === 'naik' ? 'text-emerald-600 dark:text-emerald-400' : 'text-rose-600 dark:text-rose-400'}>{trendInsight.dir} {trendInsight.pct}%</strong> selama periode ini.
                    Volatilitas {trendInsight.volatility}% — {Number(trendInsight.volatility) > 50 ? 'cukup fluktuatif, perhatikan seasonality.' : 'relatif stabil.'}
                  </span>
                </div>
              )}
            </div>

            {/* Pie/Doughnut — Komposisi per Cabang */}
            <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-4 sm:p-5 shadow-sm">
              <SectionHeader icon={IconChartPie} title="Komposisi Cabang" subtitle="Proporsi penjualan per cabang" />
              <div className="h-[260px] sm:h-[300px] flex items-center justify-center">
                {pieChartData && <Doughnut data={pieChartData} options={pieOptions} />}
              </div>
            </div>
          </div>

          {/* ═══════ RATA-RATA HARGA PER GRAM MINGGUAN ═══════ */}
          <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-4 sm:p-5 shadow-sm">
            <SectionHeader icon={IconChartLine} title="Harga Rata-rata Per Gram (Mingguan)" subtitle="Dihitung dari HARGA_JUAL ÷ BERAT setiap transaksi, lalu dirata-rata per minggu" />
            <div className="h-[280px] sm:h-[320px]">
              {weeklyPriceChartData && <Bar data={weeklyPriceChartData} options={weeklyPriceOptions} />}
            </div>
            {insightHarga && (
              <div className="mt-3 p-3 bg-slate-50 dark:bg-slate-800/50 rounded-xl text-xs text-slate-600 dark:text-slate-400 flex items-start gap-2">
                <IconInfoCircle size={16} className="text-amber-500 mt-0.5 flex-shrink-0" />
                <span>
                  Harga per gram mingguan <strong className={insightHarga.tren === 'naik' ? 'text-emerald-600 dark:text-emerald-400' : 'text-rose-600 dark:text-rose-400'}>{insightHarga.tren} {insightHarga.perubahan_persen}%</strong> dari minggu pertama ke terakhir.
                  Tertinggi: <strong className="text-amber-600 dark:text-amber-400">Rp {fmt(insightHarga.minggu_tertinggi?.avg_harga_per_gram)}</strong> ({insightHarga.minggu_tertinggi?.label}).
                  Terendah: <strong className="text-blue-600 dark:text-blue-400">Rp {fmt(insightHarga.minggu_terendah?.avg_harga_per_gram)}</strong> ({insightHarga.minggu_terendah?.label}).
                </span>
              </div>
            )}
          </div>

          {/* ═══════ RATA-RATA HARGA PER GRAM HARIAN ═══════ */}
          <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-4 sm:p-5 shadow-sm">
            <SectionHeader icon={IconChartLine} title="Harga Rata-rata Per Gram (Harian)" subtitle="Rata-rata harga jual per gram setiap harinya" />
            <div className="h-[280px] sm:h-[320px]">
              {dailyPriceChartData && <Bar data={dailyPriceChartData} options={dailyPriceOptions} />}
            </div>
            {insightHargaHarian && (
              <div className="mt-3 p-3 bg-slate-50 dark:bg-slate-800/50 rounded-xl text-xs text-slate-600 dark:text-slate-400 flex items-start gap-2">
                <IconInfoCircle size={16} className="text-emerald-500 mt-0.5 flex-shrink-0" />
                <span>
                  Harga per gram harian <strong className={insightHargaHarian.tren === 'naik' ? 'text-emerald-600 dark:text-emerald-400' : 'text-rose-600 dark:text-rose-400'}>{insightHargaHarian.tren} {insightHargaHarian.perubahan_persen}%</strong> pada periode ini.
                  Tertinggi: <strong className="text-amber-600 dark:text-amber-400">Rp {fmt(insightHargaHarian.hari_tertinggi?.avg_harga_per_gram)}</strong> ({insightHargaHarian.hari_tertinggi?.label}).
                  Terendah: <strong className="text-blue-600 dark:text-blue-400">Rp {fmt(insightHargaHarian.hari_terendah?.avg_harga_per_gram)}</strong> ({insightHargaHarian.hari_terendah?.label}).
                </span>
              </div>
            )}
          </div>

          {/* ═══════ D. PRODUKTIVITAS ═══════ */}
          <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-4 sm:p-5 shadow-sm">
            <SectionHeader icon={IconDiamond} title="Produktivitas" subtitle="Rata-rata metrik penjualan" />
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-5">
              <MetricCard label="Harga per Gram" value={`Rp ${fmt(s?.avg_harga_per_gram)}`} icon={IconScale} color="amber" />
              <MetricCard label="Gram per Item" value={`${s?.avg_gram_per_item}`} suffix=" gr" icon={IconDiamond} color="purple" />
              <MetricCard label="Profit per Item" value={`Rp ${fmt(s?.profit_per_item)}`} icon={IconReceipt} color="emerald" />
            </div>
            <div className="h-[250px] sm:h-[280px]">
              {barChartData && <Bar data={barChartData} options={barOptionsRp} />}
            </div>
          </div>

          {/* ═══════ E. INVENTORY ANALYTICS ═══════ */}
          <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-4 sm:p-5 shadow-sm">
            <SectionHeader icon={IconPackage} title="Inventory Analytics" subtitle="Analisis stok barang" />
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-5">
              <MetricCard label="Stok Masuk" value={fmt(inv?.stok_masuk)} suffix=" pcs" icon={IconPackageImport} color="blue" />
              <MetricCard label="Stok Keluar" value={fmt(inv?.stok_keluar)} suffix=" pcs" icon={IconPackageExport} color="amber" />
              <MetricCard label="Stok Tersisa" value={fmt(inv?.stok_tersisa)} suffix=" pcs" icon={IconPackage} color="emerald" />
              <MetricCard label="Dead Stock" value={fmt(inv?.dead_stock)} suffix=" pcs" icon={IconAlertTriangle} color="rose" />
            </div>
            <div className="h-[250px] sm:h-[280px]">
              {inventoryBarData && <Bar data={inventoryBarData} options={barOptions} />}
            </div>
          </div>

          {/* ═══════ KPI FORMULA REFERENCE ═══════ */}
          <div className="bg-slate-50 dark:bg-slate-900/50 border border-slate-200 dark:border-slate-800 rounded-2xl p-4 sm:p-5">
            <SectionHeader icon={IconPercentage} title="KPI Formula" subtitle="Rumus kalkulasi metrik keuangan" />
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {[
                { color: 'bg-amber-500', name: 'Gross Profit Margin', formula: '(Penjualan − HPP) ÷ Penjualan × 100' },
                { color: 'bg-emerald-500', name: 'Net Profit Margin', formula: '(Laba Kotor − Pengeluaran) ÷ Penjualan × 100' },
                { color: 'bg-blue-500', name: 'Average Price / Gram', formula: 'Total Penjualan ÷ Total Gram' },
                { color: 'bg-purple-500', name: 'Profit per Item', formula: 'Total Laba ÷ Jumlah Item' },
              ].map((f, i) => (
                <div key={i} className="flex items-start gap-3 bg-white dark:bg-slate-800 rounded-xl p-3 border border-slate-100 dark:border-slate-700">
                  <span className={`w-2.5 h-2.5 rounded-full ${f.color} mt-1.5 flex-shrink-0`} />
                  <div>
                    <p className="text-sm font-bold text-slate-800 dark:text-slate-200">{f.name}</p>
                    <p className="text-xs text-slate-500 dark:text-slate-400 font-mono mt-0.5">{f.formula}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* ═══════ 🔥 AI INSIGHTS ═══════ */}
          <div className="bg-gradient-to-br from-slate-900 to-slate-800 dark:from-slate-900 dark:to-slate-950 border border-slate-700 rounded-2xl p-4 sm:p-5 shadow-lg">
            <div className="flex items-center gap-3 mb-4">
              <div className="p-2 bg-gradient-to-br from-amber-400 to-orange-500 rounded-xl shadow-lg shadow-amber-500/20">
                <IconBrain className="text-white" size={22} />
              </div>
              <div>
                <h3 className="text-base sm:text-lg font-bold text-white flex items-center gap-2">
                  🔥 AI Insight
                </h3>
                <p className="text-xs text-slate-400">Analisis otomatis dari data penjualan</p>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
              {aiInsights.map((insight, i) => (
                <InsightCard key={i} icon={insight.icon} color={insight.color} title={insight.title} text={insight.text} />
              ))}
            </div>
          </div>
        </div>
      ) : null}
    </Layouts>
  );
};

export default DashboardKeuangan;
